import {
	Component,
	Input,
	OnChanges,
	OnDestroy,
	OnInit,
	SimpleChanges,
} from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ActionTrackerService } from 'app/services/actiontracker.service';
import { DateTime } from 'luxon';

import { IRecurrentFrequencyOptions } from '../frequency-select/frequency-select.component';

@Component({
	selector: 'appointment-recurrency',
	templateUrl: './appointment-recurrency.component.html',
	styleUrls: ['./appointment-recurrency.component.scss'],
})
export class AppointmentRecurrrency implements OnInit, OnChanges, OnDestroy {
	@Input() public formGroup: FormGroup;
	@Input() public existsAsCustomer: boolean | null;

	public recurrencyOptions: {
		value: IRecurrentFrequencyOptions;
		label: string;
	}[];

	constructor(
		private translateService: TranslateService,
		public atService: ActionTrackerService
	) {}

	ngOnInit(): void {
		this.recurrencyOptions = this.getRecurrencyOptions();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.existsAsCustomer) {
			this.recurrencyOptions = this.getRecurrencyOptions();
			this.onChangeRecurrency({ value: 'no-repeat' });
		}
	}

	ngOnDestroy(): void {
		this.formGroup.controls.recurrencyMaxSessions.clearValidators();
	}

	getFrequencyText(): string {
		if (this.formGroup.controls.recurrency.value) {
			const value = this.formGroup.controls.recurrency.value
				.toString()
				.toUpperCase();
			return this.translateService.instant(
				`APPOINTMENTS.RECURRENCY.OPTIONS.${value}.FREQUENCY`
			);
		}

		return '';
	}

	getAppointmentInitialHour(): string {
		return this.formGroup.controls.dates.value[0].time.toLocaleString(
			'pt-BR',
			DateTime.TIME_24_SIMPLE
		);
	}

	getRecurrencyOptions(): {
		value: IRecurrentFrequencyOptions;
		label: string;
	}[] {
		let options = [
			{
				value: IRecurrentFrequencyOptions.NoRepeat,
				label: this.translateService.instant(
					'APPOINTMENTS.RECURRENCY.OPTIONS.NO-REPEAT'
				),
			},
			{
				value: IRecurrentFrequencyOptions.Weekly,
				label: this.translateService.instant(
					'APPOINTMENTS.RECURRENCY.OPTIONS.WEEKLY.LABEL'
				),
			},
			{
				value: IRecurrentFrequencyOptions.Biweekly,
				label: this.translateService.instant(
					'APPOINTMENTS.RECURRENCY.OPTIONS.BIWEEKLY.LABEL'
				),
			},
			{
				value: IRecurrentFrequencyOptions.Monthly,
				label: this.translateService.instant(
					'APPOINTMENTS.RECURRENCY.OPTIONS.MONTHLY.LABEL'
				),
			},
			{
				value: IRecurrentFrequencyOptions.Custom,
				label: this.translateService.instant(
					'APPOINTMENTS.RECURRENCY.OPTIONS.CUSTOM'
				),
			},
		];
		if (!this.existsAsCustomer) {
			options = [options[0]];
		}
		return options;
	}

	getMaxValueRecurrency() {
		const maxRecurrencySessionsByRecurrency = {
			weekly: 16,
			biweekly: 8,
			monthly: 4,
		};
		return maxRecurrencySessionsByRecurrency[
			this.formGroup.controls.recurrency.value
		];
	}

	getInitialDate() {
		return DateTime.fromJSDate(
			this.formGroup.controls.dates?.value[0]?.date
		).toFormat('dd/MM/yyyy');
	}

	onChangeRecurrency(recurrency) {
		if (recurrency.value === 'custom' || recurrency.value === 'no-repeat') {
			this.formGroup.controls.recurrencyMaxSessions.setValue(null);
			this.formGroup.controls.recurrencyMaxSessions.clearValidators();
		} else {
			this.formGroup.controls.recurrencyMaxSessions.setValue(
				this.getMaxValueRecurrency()
			);
			this.formGroup.controls.recurrencyMaxSessions.setValidators([
				Validators.required,
				Validators.min(1),
				Validators.max(this.getMaxValueRecurrency()),
			]);
		}
		this.formGroup.controls.recurrencyMaxSessions.updateValueAndValidity();
	}
}
